/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Load global styles
import '@mdi/font/css/materialdesignicons.css';
import '@/styles/main.scss';

// App setup
import { createApp } from 'vue';
import App from './App.vue';
import { registerPlugins } from '@/plugins';
import axios from 'axios';
import { useReportsStore } from '@/store';

// katex
import 'katex/dist/katex.min.css';
// @ts-ignore
import katex from 'katex';
(window as any).katex = katex;

// Create and configure the Vue app
const app = createApp(App);
app.config.globalProperties.axios = axios;
registerPlugins(app);

// Initialize the reports store before mounting
const reportsStore = useReportsStore();

// Mount the app after store initialization
reportsStore
  .initialize()
  .then(() => {
    app.mount('#app');
  })
  .catch((error) => {
    console.error('Fatal initialization error:', error);
    app.mount('#app');
  });

// Cleanup store when app is unmounted
app.unmount = (() => {
  const originalUnmount = app.unmount;
  return () => {
    reportsStore.cleanup();
    originalUnmount();
  };
})();
